<div class="locale-tab-content">
    <div *ngIf="!appLocaleService.addInProgress" class="message-header full-width row scroll-visible">
        <div
            [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
            <ul class="list-items messages">
                <li class="list-item">
                    <div class="item">
                        <label class="app-label title">{{locale.LABEL_PROPERTY_DISPLAYFORMAT}}</label>
                    </div>
                </li>
            </ul>
        </div>
        <div
            [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
            <ul class="list-items messages">
                <li class="list-item" [ngClass]="{'last-item': !appLocaleService.multipleLocaleExists}">
                    <div class="item">
                        <label class="app-label title">{{locale.LABEL_LANG_ENGLISH}}</label>
                    </div>
                </li>
            </ul>
        </div>
        <div *ngIf="appLocaleService.multipleLocaleExists"
            [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
            <ul class="list-items messages">
                <li class="list-item last-item select-container">
                    <div class="item">
                        <select class="form-control app-select" name="wm-locale-select"
                            [(ngModel)]="appLocaleService.selectedTempLocale.key">
                            <option *ngFor="let map of appLocaleService.supportedLocaleCodesMap | keyvalue"
                                [value]="map.key">{{map.value}}
                            </option>
                        </select>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="message-table row" *ngIf="!appLocaleService.addInProgress">
        <div
            [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
            <ul class="list-items messages">
                <!-- preferences['project.i18n.edit'] &&  -->
                <li (click)="editFormat($event, format)" class="list-item" title="{{format}}" [ngClass]="{'active': appLocaleService.activeFormat.en && appLocaleService.activeFormat.en[format]}"
                    *ngFor="let format of appLocaleService.formatsList">
                    <div class="item">
                        <div class="title">{{format}}</div>
                    </div>
                </li>
            </ul>
        </div>
        <div
            [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
            <ul class="list-items messages">
                <!-- preferences['project.i18n.edit'] &&  -->
                <li (click)="editFormat($event, format)" class="list-item"
                    title="{{appLocaleService.userFormats.en[format]}}"
                    [ngClass]="{'compress': appLocaleService.activeFormat.en && appLocaleService.activeFormat.en[format]}"
                    *ngFor="let format of appLocaleService.formatsList">
                    <div class="item">
                        <div *ngIf="!appLocaleService.activeFormat.en || !appLocaleService.activeFormat.en[format]"
                            class="title">{{appLocaleService.userFormats.en[format]}}
                        </div>
                        <input class="form-control app-textbox" (click)="appLocaleService.onInputClick($event)" [attr.list]="'locale-settings-' + format + '-patterns-list'"
                            *ngIf="appLocaleService.activeFormat.en && appLocaleService.activeFormat.en[format]"
                            [(ngModel)]="appLocaleService.userFormats.en[format]" [ngModelOptions]="{'updateOn': 'change'}">
                        <button class="close pull-right"
                            *ngIf="appLocaleService.activeFormat.en && appLocaleService.activeFormat.en[format]"
                            (click)="editFormat($event);" title="{{locale.LABEL_CLOSE}}"><i
                                class="wm-icon wms wms-done"></i></button>
                    </div>
                </li>
            </ul>
        </div>
        <div *ngIf="appLocaleService.multipleLocaleExists"
            [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
            <ul class="list-items messages">
                <!-- preferences['project.i18n.edit'] && -->
                <li (click)="editFormat($event, format)" class="list-item"
                    title="{{appLocaleService.userFormats[appLocaleService.selectedTempLocale.key][format]}}"
                    [ngClass]="{'compress': appLocaleService.activeFormat[appLocaleService.selectedTempLocale.key] && appLocaleService.activeFormat[appLocaleService.selectedTempLocale.key][format], 'marked-deleted': appLocaleService.isMessageDeleted(format)}"
                    *ngFor="let format of appLocaleService.formatsList"
                    [ngClass]="{'marked-deleted': appLocaleService.isMessageDeleted(format)}">
                    <div class="item">
                        <div *ngIf="(!appLocaleService.activeFormat[appLocaleService.selectedTempLocale.key] || !appLocaleService.activeFormat[appLocaleService.selectedTempLocale.key][format]) && (appLocaleService.userFormats[appLocaleService.selectedTempLocale.key] && appLocaleService.userFormats[appLocaleService.selectedTempLocale.key][format])"
                            class="title">
                            {{appLocaleService.userFormats[appLocaleService.selectedTempLocale.key][format]}}
                        </div>
                        <div *ngIf="(!appLocaleService.activeFormat[appLocaleService.selectedTempLocale.key] || !appLocaleService.activeFormat[appLocaleService.selectedTempLocale.key][format]) && (!appLocaleService.userFormats[appLocaleService.selectedTempLocale.key] || !appLocaleService.userFormats[appLocaleService.selectedTempLocale.key][format])"
                            class="title">
                            &nbsp;
                        </div>
                        <input class="form-control app-textbox" (click)="appLocaleService.onInputClick($event)" [attr.list]="'locale-settings-' + format + '-patterns-list'"
                            *ngIf="appLocaleService.activeFormat[appLocaleService.selectedTempLocale.key] && appLocaleService.activeFormat[appLocaleService.selectedTempLocale.key][format]"
                            [(ngModel)]="appLocaleService.userFormats[appLocaleService.selectedTempLocale.key][format]"
                            [ngModelOptions]="{'updateOn': 'change'}">
                        <button class="close pull-right"
                            *ngIf="appLocaleService.activeFormat[appLocaleService.selectedTempLocale.key] && appLocaleService.activeFormat[appLocaleService.selectedTempLocale.key][format]"
                            (click)="editFormat($event);" title="{{locale.LABEL_CLOSE}}"><i
                                class="wm-icon wms wms-done"></i></button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
